import pen from '../assets/pen.png';
import chat_bubbles from '../assets/chat_bubbles.png';
import check_mark from '../assets/check_mark.png';
import arrow from '../assets/yellow_arrow.png';
export default function HowDoesItWork(props) {
    return (
        <div id={props.id} style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div className="line-container">
                <span className="horizontal-line line-left"></span>
                <div className="pill-box">
                    How does it work?
                </div>
                <span className="horizontal-line line-right"></span>
            </div>
            <h1 className="how-does-it-work-title">We write your story one chapter at a time</h1>
            <h2 className="how-does-it-work-subtitle">Start with one chapter. Only come back for more if you love it.</h2>
            <div className="clothesline-container">
                <div className="clothesline-step">
                    <div className="dot"></div>
                    <div className="hanger-shape">
                        <img src={pen} />
                        <h3>Pick a topic</h3>
                        <p>Pick a topic we can cover in about an hour.</p>
                    </div>
                </div>
                <div className="clothesline-step">
                    <div className="dot"></div>
                    <div className="hanger-shape">
                        <img src={chat_bubbles} alt="Icon 2" />
                        <h3>Chat on Zoom</h3>
                        <p>We'll chat over Zoom to gather all the details.</p>
                    </div>
                </div>
                <div className="clothesline-step">
                    <div className="dot"></div>
                    <div className="hanger-shape">
                        <img src={check_mark} alt="Icon 3" />
                        <h3>That's it!</h3>
                        <p>We'll write a first draft within a few days.</p>
                    </div>
                </div>
            </div>
            <img src={arrow} className="main-intro-yellow-arrow" />
        </div>
        
    )
}